import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import {
  PaymentLinkLandingComponentActions,
  PaymentLinkLandingComponentPaymentLinkActions,
  PaymentLinkLandingComponentPermissionActions,
} from '..';
import { BaseEffect } from '@arc/unified-payments-frontend/shared-stores';
import {
  LoadingSpinnerService,
  PaymentLinkService,
} from '@arc/unified-payments-frontend/shared-payment';
import { of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class PaymentLinkLandingComponentEffects extends BaseEffect {
  constructor(
    private paymentLinkService: PaymentLinkService,
    actions$: Actions,
    loadingSpinnerService: LoadingSpinnerService,
  ) {
    super(actions$, loadingSpinnerService);
  }

  /* istanbul ignore next */
  loadUntilInitialized$ = createEffect(
    () =>
      this.loadUntilActionsComplete(
        [PaymentLinkLandingComponentActions.initialize.type],
        [
          PaymentLinkLandingComponentPaymentLinkActions
            .exchangeTokenForSessionError.type,
          PaymentLinkLandingComponentPermissionActions
            .verifyUserIsProvisionedSuccess.type,
          PaymentLinkLandingComponentPermissionActions
            .verifyUserIsProvisionedError.type,
        ],
      ),
    { dispatch: false },
  );

  exchangeTokenForSession$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PaymentLinkLandingComponentActions.initialize),
      map((action) => action.paymentLinkToken),
      exhaustMap((paymentLinkToken) =>
        this.paymentLinkService
          .getSessionFromPaymentLink(paymentLinkToken)
          .pipe(
            map((response) =>
              PaymentLinkLandingComponentPaymentLinkActions.exchangeTokenForSessionSuccess(
                {
                  response,
                },
              ),
            ),
            catchError((error: HttpErrorResponse) =>
              of(
                PaymentLinkLandingComponentPaymentLinkActions.exchangeTokenForSessionError(
                  {
                    error,
                  },
                ),
              ),
            ),
          ),
      ),
    ),
  );
}
